module.exports = __webpack_public_path__ + "static/media/invlogo-sm.ce05c62e.png";